import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const RelatedLinks = ({ links = [] }) => {
  if (!links.length) return null;
  return (
    <div className="sp-related-grid">
      {links.map((l) => (
        <Link to={l.path} className="sp-related-card" key={l.path}>
          <span className="sp-related-title">{l.label}</span>
          {l.blurb && <span className="sp-related-blurb">{l.blurb}</span>}
          <span className="sp-related-cta">Explore <ArrowRight size={15} /></span>
        </Link>
      ))}
    </div>
  );
};

export default RelatedLinks;
